import { IOption } from '@cbridge-utils/options';
import { IRuleRowModel, RuleStatus } from '@cbridge-tools/rules-data-grid';
import { ISymbol } from '@cbridge-packages/symbol';
import { ISymbolClient } from '@cbridge-packages/symbol-client';
import { IServer } from '@cbridge-packages/server';
import { IStream } from '@cbridge-packages/stream';

export interface IRuleManagementRowModel extends IRuleRowModel, IRuleValidation {
  propsBeforeDelete?: {
    status?: RuleStatus;
    invalid?: boolean;
  };
}

export interface IRuleValidation {
  errors?: RuleValidationError[];
  warnings?: IRuleWarnings;
}

export interface IRuleValidationResult extends IRuleValidation {
  index: number;
}

export interface RuleValidationError {
  code: RuleErrorCode;
  key: RuleErrorKey;
  ref?: (number | string)[] | string | number;
}

export enum RuleErrorCode {
  NotFound = 'notFound',
}

export enum RuleWarningType {
  Unused = 'unused',
  Useless = 'useless',
}

export enum RuleWarningKey {
  StreamId = 'streamId',
  SymbolGroup = 'symbolGroup',
  CoreSymbol = 'coreSymbol',
  ClientSymbol = 'clientSymbol',
}

export enum RuleWarningNoMapping {
  ServerId = 'serverId',
  StreamId = 'streamId',
  CoreSymbol = 'coreSymbol',
  ClientSymbol = 'clientSymbol',
}

export interface IRuleUselessNoMappingItem {
  key: RuleWarningKey;
  noMapping: RuleWarningNoMapping;
}

// A backend message shown verbatim (e.g. a rejected field combination).
export interface IRuleUselessMessageItem {
  message: string;
}

export type IRuleUselessWarningItem = IRuleUselessNoMappingItem | IRuleUselessMessageItem;

export interface IRuleWarningsUnused {
  unused: boolean;
}

export interface IRuleWarningsUseless {
  useless: IRuleUselessWarningItem[];
}

export type IRuleWarnings = IRuleWarningsUnused | IRuleWarningsUseless;

export enum RuleErrorKey {
  CoreSymbol = 'coreSymbol',
  ClientSymbol = 'clientSymbol',
  ProfileId = 'profileId',
  ServerId = 'serverId',
  StreamId = 'streamId',
  SymbolGroup = 'symbolGroup',
  LpId = 'lpId',
  AccountId = 'accountId',
}

export interface IBasicRule extends IRuleValidation {
  profile: IOption<number>;
  coreSymbols?: IOption<ISymbol['symbolId']>[];
  clientSymbols?: IOption<ISymbolClient['clientSymbolName']>[];
  server?: IOption<IServer['serverId']>;
  stream?: IOption<IStream['streamId']>;
  symbolGroup?: string;
}

export interface IClientRule extends IBasicRule {
  clientSymbols?: IOption<ISymbolClient['clientSymbolName']>[];
}

export interface IRuleId {
  id?: number;
}

export interface IBasicRuleImported extends IBasicRule, IRuleId { }

export interface IClientRuleImported extends IClientRule, IRuleId { }
